import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=0ef7f0b8&scoped=true&"
import script from "./AddArea.vue?vue&type=script&lang=ts&"
export * from "./AddArea.vue?vue&type=script&lang=ts&"
import style0 from "./AddArea.vue?vue&type=style&index=0&id=0ef7f0b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef7f0b8",
  null
  
)

export default component.exports